import { array, object, ObjectSchema, ref, string, StringSchema } from 'yup';

import { FormErrorMessage } from '~/constants/messages';
import { katakanaRegexp, usernameRegexp } from '~/constants/regexp';
import { PractitionerRole } from '~/graphql/generated/graphql';
import { optionalPasswordSchema, PasswordPolicy } from '~/utils/password';

import { Fields } from './types';

export const validationSchema: ObjectSchema<Fields> = object({
  givenName: string().label('氏名').required(FormErrorMessage.required),
  familyName: string().label('氏名').required(FormErrorMessage.required),
  phoneticFamilyName: string()
    .label('氏名（カナ）')
    .required(FormErrorMessage.required)
    .matches(katakanaRegexp, FormErrorMessage.katakana),
  phoneticGivenName: string()
    .label('氏名（カナ）')
    .required(FormErrorMessage.required)
    .matches(katakanaRegexp, FormErrorMessage.katakana),
  username: string()
    .label('ユーザーID')
    .min(6, FormErrorMessage.minLengthRequiredAlpha)
    .matches(usernameRegexp, FormErrorMessage.alpha)
    .required(FormErrorMessage.required),
  roles: array()
    .of(string().equals(['admin', 'clerk', 'company_admin', 'pharmacist'] as PractitionerRole[]))
    .required(FormErrorMessage.required),
  password: string().label('パスワード').notRequired() as StringSchema,
  passwordConfirmation: string().label('パスワード（確認）').notRequired() as StringSchema,
});

export const validationUpdateSchema = (policy: PasswordPolicy): ObjectSchema<Fields> =>
  object({
    givenName: string().label('氏名').required(FormErrorMessage.required),
    familyName: string().label('氏名').required(FormErrorMessage.required),
    phoneticFamilyName: string()
      .label('氏名（カナ）')
      .required(FormErrorMessage.required)
      .matches(katakanaRegexp, FormErrorMessage.katakana),
    phoneticGivenName: string()
      .label('氏名（カナ）')
      .required(FormErrorMessage.required)
      .matches(katakanaRegexp, FormErrorMessage.katakana),
    username: string().label('ユーザーID').notRequired() as StringSchema,
    roles: array()
      .of(string().equals(['admin', 'clerk', 'company_admin', 'pharmacist'] as PractitionerRole[]))
      .required(FormErrorMessage.required),
    password: optionalPasswordSchema(policy),
    passwordConfirmation: string()
      .label('パスワード（確認）')
      .oneOf([ref('password')], FormErrorMessage.passwordMismatch)
      .when('password', {
        is: (value: string) => value.length > 0,
        then: (schema) => schema.label('パスワード（確認）').required(FormErrorMessage.required),
      }),
  });
